import React from 'react';
import { StyleSheet, View } from 'react-native';

import Colors from '../../theming/Colors';
import Spacing from '../../theming/Spacing';
import KitText from '../KitText';

interface IKitInputValidationMessageProps {
  children: React.ReactNode;
  message: string;
  isNotValid: boolean;
  bottom?: number;
}

export default function KitInputValidationMessage({
  children,
  message,
  isNotValid,
  bottom = -40,
}: IKitInputValidationMessageProps): JSX.Element {
  return (
    <View>
      {children}
      {isNotValid && (
        <View style={[styles.container, { bottom }]}>
          <KitText color={Colors.N0} fontSize={18}>
            {message}
          </KitText>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    backgroundColor: Colors.R500,
    paddingHorizontal: Spacing.m,
    paddingVertical: 7,
    borderRadius: Spacing.s,
  },
});
